import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Sends a Google Analytics `page_view` event on every React Router navigation.
 *
 * GA's default `gtag('config', ...)` only fires on hard page loads. In an SPA
 * that means moving between Dashboard / Opportunities / Profile etc. would
 * silently NOT be recorded. This hook closes that gap.
 */
export default function RouteTracker() {
  const location = useLocation();
  useEffect(() => {
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;
    window.gtag("event", "page_view", {
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location.pathname, location.search]);
  return null;
}
